module.exports = __webpack_public_path__ + "static/media/pattern.a7d96638.png";